export class Company {
}
//# sourceMappingURL=company.js.map